"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    api: {
        host: "api.music.yandex.net",
        port: 443,
        scheme: "https",
    },
    authApi: {
        host: "oauth.mobile.yandex.net",
        port: 443,
        scheme: "https",
    },
    oauth: {
        CLIENT_ID: "23cabbbdc6cd418abb4b39c32c41195d",
        CLIENT_SECRET: "53bc75238f0c4d08a118e51fe9203300",
    },
    fake_device: {
        DEVICE_ID: "377c5ae26b09fccd72deae0a95425559",
        UUID: "3cfccdaf75dcf98b917a54afe50447ba",
        PACKAGE_NAME: "ru.yandex.music",
    },
};
